import { getMessaging, getToken } from 'firebase/messaging';
import { app } from './firebaseKeys';
import { STORAGE_KEYS } from '../constants/storage';
import { load, save } from './storage';

const firebaseCloudMessaging = {
  init: async () => {
    try {
      const messaging = getMessaging(app);
      const tokenInLocalForage = await load(STORAGE_KEYS.fcmToken);

      if (tokenInLocalForage) {
        return tokenInLocalForage;
      }

      const status = await Notification.requestPermission();
      if (status && status === 'granted') {
        const swRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        const fcm_token = await getToken(messaging, {
          vapidKey:
            'BAwkfMHknsdxUkSqIRxPk1FhF6-9VgCGZhzBLHAkKUzIxWGPmHKWXhD_KN2aNosUx8KDKDOhYLWsyulZeaVvcYM',
          serviceWorkerRegistration: swRegistration,
        });

        if (fcm_token) {
          save(STORAGE_KEYS.fcmToken, fcm_token);
          return fcm_token;
        }
      } else {
        console.warn('Notification permission not granted.');
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    // }
  },
};

export { firebaseCloudMessaging };